if (!customElements.get('gift-preview')) {
  customElements.define('gift-preview', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger = this.querySelector('.gift-preview__trigger');
      this.panel = this.querySelector('.gift-preview__panel');
      if (!this.trigger || !this.panel) return;
      this.trigger.addEventListener('pointerdown', (event) => {
        this.lastPointerType = event.pointerType;
      }, options);
      this.trigger.addEventListener('click', (event) => {
        // Mouse clicks must never latch a hover preview open. Keyboard
        // activation and touch/pen taps retain an explicit open/close action.
        const pointerType = event.pointerType || this.lastPointerType;
        if (event.detail !== 0 && pointerType === 'mouse') return;
        this.setOpen(this.panel.hidden);
      }, options);
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') this.setOpen(true);
      }, options);
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') this.close(false);
      }, options);
      this.querySelector('.gift-preview__close').addEventListener('click', () => this.close(true), options);
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) this.close(false);
      }, options);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.panel.hidden) {
          event.stopPropagation();
          this.close(this.contains(document.activeElement));
        }
      }, { ...options, capture: true });
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.close(false);
      }, options);
    }
    setOpen(open) {
      if (open) document.querySelectorAll('gift-preview').forEach((preview) => {
        if (preview !== this && preview.close) preview.close(false);
      });
      this.panel.hidden = !open;
      this.trigger.setAttribute('aria-expanded', String(open));
    }
    close(focus) {
      this.setOpen(false);
      if (focus) this.trigger.focus();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
